import {ReactComponent as PhoneAltIcon} from './phoneAlt.svg'

function PhoneAlt() {
  return <PhoneAltIcon />
}

export default PhoneAlt
